import React, { useEffect, useState } from 'react';
import Icon from '../../common/Icons';
import AdminPersonnelModal, {
  ModalFormGroup,
  ModalFooterActions
} from '../ui/AdminPersonnelModal';

const FORM_ID = 'ap-member-archive-form';

/**
 * Confirmation d'archivage (débauche) d'un adhérent, avec motif optionnel.
 * Pour un agent titulaire, l'archivage embarque tout son foyer (ayants-droit).
 */
const MemberArchiveModal = ({ show, onHide, member, bulkCount = 0, onConfirm, submitting }) => {
  const [reason, setReason] = useState('');

  const isBulk = bulkCount > 0;

  useEffect(() => {
    if (show) setReason('');
  }, [show, member, bulkCount]);

  if (!isBulk && !member) return null;

  const isAgent = member?.type === 'AGENT';
  const fullName = `${member?.nom || ''} ${member?.prenom || ''}`.trim() || 'cet adhérent';
  const subtitle = isBulk
    ? `${bulkCount} adhérent${bulkCount > 1 ? 's' : ''} sélectionné${bulkCount > 1 ? 's' : ''}`
    : fullName;

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(reason.trim());
  };

  return (
    <AdminPersonnelModal
      show={show}
      onHide={onHide}
      size="lg"
      icon="inbox"
      badge="Débauche"
      title={isBulk ? 'Archiver les adhérents sélectionnés' : "Archiver l'adhérent"}
      subtitle={subtitle}
      ariaLabelledBy="ap-member-archive-title"
      footer={
        <ModalFooterActions
          onCancel={onHide}
          primary={
            <button
              type="submit"
              form={FORM_ID}
              className="ap-modal-btn ap-modal-btn--primary"
              disabled={submitting}
            >
              <Icon name="inbox" size={14} />
              {submitting
                ? 'Archivage…'
                : isBulk
                  ? `Archiver ${bulkCount} adhérent${bulkCount > 1 ? 's' : ''}`
                  : "Archiver l'adhérent"}
            </button>
          }
        />
      }
    >
      <form id={FORM_ID} className="ap-modal-form" onSubmit={handleSubmit}>
        <p style={{ marginTop: 0, color: 'var(--ap-text-muted, #64748b)', fontSize: '0.9rem' }}>
          {isBulk ? (
            <>
              Les adhérents sélectionnés ne seront pas supprimés : leurs fiches et tout leur
              historique sont conservés dans les archives. Vous pourrez les réintégrer
              (réembauche) à tout moment. Tout agent titulaire sélectionné archivera également
              l'ensemble de son foyer (ayants-droit). Le motif s'applique à toute la sélection.
            </>
          ) : (
            <>
              L'adhérent ne sera pas supprimé : sa fiche et tout son historique sont conservés
              dans les archives. Vous pourrez le réintégrer (réembauche) à tout moment.
              {isAgent
                ? " Comme il s'agit d'un agent titulaire, l'ensemble de son foyer (ayants-droit) sera archivé avec lui."
                : ''}
            </>
          )}
        </p>

        <ModalFormGroup label="Motif de la débauche (optionnel)" htmlFor="mem-archive-reason">
          <textarea
            id="mem-archive-reason"
            className="ap-modal-input"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            maxLength={255}
            placeholder="Ex. : départ à la retraite, fin de contrat, démission…"
          />
        </ModalFormGroup>
      </form>
    </AdminPersonnelModal>
  );
};

export default MemberArchiveModal;
